export default __webpack_public_path__ + "static/media/kitchen5-afterA-1024w.df9d6b28.png";